import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { DateService } from '@app-core/services/date/date.service';
import { getDriverQueryState } from '@app-driver-management/reducers';
import { State } from '@app-driver-management/reducers/driver-query.reducer';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Days, DurationRange } from '@app-core/models/core.model';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
@Component({
  selector: 'app-driver-query',
  templateUrl: './driver-query.component.html',
  styleUrls: ['./driver-query.component.scss'],
})
export class DriverQueryComponent implements OnInit, OnDestroy {
  public driverQueryState: any;
  @Input()
  public driverList = [];
  @Input()
  public isCoachingRequired = false;
  @Output()
  private search: EventEmitter<any> = new EventEmitter<any>();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public durationRange: DurationRange;
  public customOptions = {
    showLargeInput: true,
    showAdditionalDisplayProp: true,
    additionalDisplayPropKey: 'driverName',
  };

  public form = this.fb.group({
    driverId: ['', [Validators.required]],
    days: [<Days>null, Validators.required],
    formStartDate: [<Date | null>null, [Validators.required]],
    formEndDate: [<Date | null>null, [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private dateService: DateService,
    private store: Store<State>,
    private mixpanelService: MixPanelService
  ) {}

  public ngOnInit() {
    this.store
      .select(getDriverQueryState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((driverQueryState) => {
        this.driverQueryState = driverQueryState;
        const { days, displayStartDate: startDate, displayEndDate: endDate } = driverQueryState;
        this.durationRange = { days, startDate, endDate };
        this.form.patchValue({
          days: days,
          formStartDate: startDate,
          formEndDate: endDate,
          driverId: this.driverQueryState.driverId,
        });
      });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.unsubscribe();
  }

  public durationChange(durationRange: DurationRange) {
    const { days, startDate, endDate } = durationRange;
    if (days && startDate && endDate) {
      this.form?.patchValue({
        days: days,
        formStartDate: startDate,
        formEndDate: endDate,
      });
    }
    this.mixpanelService.track('Select date range driver - Details page', {
      Days: days,
    });
    this.onSearch();
  }

  /**
   * Function called on click of search button
   *
   * Emit search event.
   */
  public onSearch() {
    const { days, driverId, formStartDate = '', formEndDate = '' } = this.form.value;

    if (driverId === '' || formStartDate === '' || formEndDate === '') {
      return;
    }

    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliSeconds = now.getMilliseconds();
    // Setting current Hours, minutes and seconds since datepicker only sets date part.
    const from = this.dateService.toDaysStartISO(new Date(formStartDate.setHours(hours, minutes, seconds, milliSeconds)));
    const to = this.dateService.toDaysEndISOPlusOne(new Date(formEndDate.setHours(hours, minutes, seconds, milliSeconds)));
    this.search.emit({
      days: days,
      driverId,
      displayStartDate: formStartDate,
      displayEndDate: formEndDate,
      paramStartDate: from,
      paramEndDate: to,
    });
  }
}
